var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPerformance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 1.514a1.4 1.4 0 011.4 1.4v10.4a1.4 1.4 0 01-1.4 1.4H2.8a1.4 1.4 0 01-1.4-1.4v-10.4a1.4 1.4 0 011.4-1.4h10.4zm-10.4 1.2a.2.2 0 00-.2.2v10.4c0 .11.09.2.2.2h10.4c.11 0 .2-.09.2-.2v-10.4a.2.2 0 00-.2-.2H2.8zm8.444 2.115c.458 0 .828.37.828.828v2.617a.6.6 0 01-1.2 0V6.987L7.942 9.92a.715.715 0 01-.984.025l-.807-.727-1.627 1.606a.6.6 0 01-.842-.854L5.635 8.04a.715.715 0 01.868-.105l.112.083.803.725 2.717-2.716H8.627a.6.6 0 110-1.199h2.617z"
  })));
}
export default SvgIconPerformance;